import {Component} from "@angular/core";

@Component({
    selector: "fui-page-utility",
    styleUrls: ["./page-utility.component.scss"],
    templateUrl: "./page-utility.component.html"
})
export class FUIPageUtilityComponent {
    constructor() {
    }
}
